import { LoginRequest, VerifyOTPRequest, SignupRequest, OTPRequest, AuthResponse } from "../types";
import { login, logout, signup, verifySmsOtp, sendEmailOtp, sendSmsOtp, verifyEmailOtp } from "../api/auth";

export const useAuth = () => {
    const loginFunction = async (data: LoginRequest): Promise<AuthResponse> => {
        const response = await login(data);
        return response;
    };
    const logoutFunction = async () => {
        const response = await logout();
        return response;
    };
    const signupFunction = async (data: SignupRequest) => {
        const response = await signup(data);
        return response;
    };
    const verifySmsOtpFunction = async (data: VerifyOTPRequest) => {
        const response = await verifySmsOtp(data);
        return response;
    };
    const verifyEmailOtpFunction = async (data: VerifyOTPRequest) => {
        const response = await verifyEmailOtp(data);
        return response;
    };
    const sendEmailOtpFunction = async (data: OTPRequest) => {
        const response = await sendEmailOtp(data);
        return response;
    };
    const sendSmsOtpFunction = async (data: OTPRequest) => {
        const response = await sendSmsOtp(data);
        return response;
    };
  return {
    loginFunction,
    logoutFunction,
    signupFunction,
    verifySmsOtpFunction,
    verifyEmailOtpFunction,
    sendEmailOtpFunction,
    sendSmsOtpFunction,
  };
};